












































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { IDowningRes } from '@/api/files/files-updown/res'
import { getAndroidDowningList, putDownAppAndroid, getAndroidAppChannelList, removeDowningAppAndroid } from '@/api/files/files-updown/filesUpdown'

import { Form } from 'element-ui'
import { resetObjValue2NoneString } from '@/utils/tool'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'
import { getDownReason, getAndroidSource, getDownStatus, getSearchCategory } from '@/api/common'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'FilesUpdownAndroidDowning'
})
export default class extends mixins(DateOption) {
  // data
  private params = {
    id: '',
    name: '',
    fileBundleid: '',
    offlineReason: '',
    source: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private downParams = {
    id: '',
    channel: [],
    type: '',
    reason: '',
    detail: ''
  }
  // template data
  private sourceList: Array<ISelectItem> = []
  private downReasonList: ISelectItem[] = []
  private downStatusList: ISelectItem[] = []
  private channelList: Array<{id: string, name: string, disabled?: boolean}> = []
  private appChannelList: any[] = []
  private showFormItem: boolean = false
  private downFormVisible: boolean = false
  private tableData: IDowningRes[] = []
  private selectedData: IDowningRes[] = []
  private totalCount: number = 0
  private dateArray: string[] = ['', '']
  routeQuery: IQuery = { id: 0, platform: 'android' }
  private rules: any = {
    id: [{ required: true, message: '请输入ID', trigger: 'blur' }],
    channel: [{ required: true, message: '选择语言渠道', trigger: 'change' }],
    startDate: [
      {
        required: true,
        message: '请选择开始时间',
        trigger: 'blur'
      }
    ],
    distributeArea: [{ type: 'array', required: true, message: '请至少选择一个地区', trigger: 'change' }]
  }
  private isAllDown: boolean = false
  tableLoading = false
  openWindow: any
  tableHeight: number = 500
  // lifecycle
  created() {
    this.getTableData()
    this.getAndroidSource()
    this.getDownReasonList()
    this.getAllChannel()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getAndroidDowningList(this.params)
    this.tableData = res.data.dataList || []
    if (this.tableData.length <= 0) {
      this.tableLoading = false
      return
    }
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    let all = res.data.dataList.map((item: any) => getImgURLOfBase64(item.icon, header))
    Promise.all(all).then(arr => {
      for (let i = 0; i < arr.length; i++) {
        this.tableData[i]['icon'] = arr[i] as string
        this.tableLoading = false
        this.totalCount = res.data.pageInfo.totalCount
      }
    }).catch(err => {
      console.log(err)
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
    })
  }
  async getAndroidSource() {
    let res = await getAndroidSource()
    this.sourceList = res.data.dataList
  }
  async getDownReasonList() {
    let res = await getDownReason()
    this.downReasonList = res.data
  }
  async getDownStatusList() {
    let res = await getDownStatus()
    this.downStatusList = res.data
  }
  async getAllChannel() {
    let res: any = await getSearchCategory({
      isIos: false
    })
    let list = res.data
    this.channelList = list.map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        disabled: false
      }
    })
  }
  async getAndroidAppChannelList(id: number) {
    let res = await getAndroidAppChannelList({ id })
    this.appChannelList = res.data.dataList
    return res.data.dataList
  }
  async putDownAppAndroid() {
    let res: any = await putDownAppAndroid({
      ids: this.downParams.id,
      channel: this.downParams.channel.join(','),
      type: this.downParams.type,
      reason: this.downParams.reason,
      remark: this.downParams.detail
    })
    if (res.status.code === 0) {
      this['$message'].success('提交成功!')
      this.cancelDownForm()
    } else {
      this['$message'].error('提交失败!')
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 260 - filterDom.clientHeight
  }
  removeDowningAppAndroid(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await removeDowningAppAndroid({ ids })
        if (res.status.code === 0) {
          this['$message'].success('移除成功!')
          this.getTableData()
        } else {
          this['$message'].error('移除失败!')
        }
      })
      .catch(() => {})
  }
  handleDateChange(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArray = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: IDowningRes[]) {
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleDownAll() {
    this.isAllDown = true
    this.getDownReasonList()
    this.getDownStatusList()
    this.downFormVisible = true
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    this.downParams.id = t.join(',')
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.removeDowningAppAndroid(ids)
  }
  goToDetail(item: IDowningRes) {
    this.routeQuery.id = item.id
    this.openWindow({
      name: 'AppDetail',
      query: this.routeQuery
    })
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  handleFormClose() {
    this.resetChannelList()
    this.isAllDown = false
  }
  resetChannelList() {
    this.channelList.forEach(item => {
      item.disabled = false
    })
  }
  async downApp(item: IDowningRes) {
    this.downFormVisible = true
    await this.getDownReasonList()
    await this.getDownStatusList()
    let hasSelectedChannelList = await this.getAndroidAppChannelList(item.id)
    this.channelList.forEach(item => {
      if (!hasSelectedChannelList.includes(item.id)) {
        item.disabled = true
      }
    })
    console.log(this.channelList)
    this.downParams.id = (item.id).toString()
  }
  removeApp(item: IDowningRes) {
    let ids = item.id.toString()
    this.removeDowningAppAndroid(ids)
  }
  cancelDownForm() {
    (this.$refs['downParams'] as Form).resetFields()
    this.downParams.detail = ''
    this.downFormVisible = false
  }
  confirmDownForm() {
    (this.$refs['downParams'] as Form).validate(valid => {
      if (valid) {
        this.putDownAppAndroid()
      } else {
        this['$message'].error('请填写缺失参数!')
        return false
      }
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  @Watch('downParams', { deep: true })
  onChannelChange(nv: any, ov: any) {
    if (nv.channel.length === this.appChannelList.length) {
      this.showFormItem = true
    } else {
      this.showFormItem = false
    }
  }
}
